import type {
  CreateMyCompanyRequest,
  MyCompanyListResponse,
  OnboardingCompanyResponse,
  SwitchActiveCompanyRequest
} from '@tandemone/types'

import { api } from '@/api/client'

export async function getMyCompanies(
  signal?: AbortSignal
): Promise<MyCompanyListResponse> {
  const { data } = await api.get<MyCompanyListResponse>('/v1/me/companies', {
    signal
  })
  return data
}

export async function switchActiveCompany(
  body: SwitchActiveCompanyRequest
): Promise<void> {
  await api.post('/v1/me/active-company', body)
}

export async function createMyCompany(
  body: CreateMyCompanyRequest
): Promise<OnboardingCompanyResponse> {
  const { data } = await api.post<OnboardingCompanyResponse>(
    '/v1/me/companies',
    body
  )
  return data
}
